import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getRevenueShares = async (
  token,
  type = null,
  page = null,
  pageSize = null
) => {
  const endpoint =
    type === null
      ? `/api/v1/admin/revenue_shares?page=${page}&per_page=${pageSize}`
      : `/api/v1/admin/revenue_shares?type=${type}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
